import axios from '../request'
export default {
  InitialPort: {
    login: params => axios.post('/m/login/salogin', params)
  },
  // 堆场新提交的信息
  showH5YardInfo: params =>
    axios.post('/materials/tQdRepoMaintenance/findBestNewListByCreateTime', params),
  //H5堆场信息提交
  submitH5YardInfo: params =>
    axios.post('/materials/tQdRepoMaintenance/h5submit', params),
  // 静养新提交的信息
  showH5TestInfo: params =>
    axios.post('/materials/tQdRestDataMaintenance/findBestNewListByCreateTime', params),
  //H5堆场信息提交
  submitH5TestInfo: params =>
    axios.post('/materials/tQdRestDataMaintenance/h5submit', params),
  // 发运新提交的信息
  showH5DuctInfo: params =>
    axios.post('/materials/QdShippingMaintenance/findBestNewListByCreateTime', params),
  //H5发运信息提交
  submitH5DuctInfo: params =>
    axios.post('/materials/QdShippingMaintenance/h5submit', params),
  PieceProduct: {
    getLists: params => axios.post('/screen/sa/gpndscList', params),
    addRow: params => axios.post('/screen/sa/addGpndsc', params)
  }, // 管片生产
  WatertMonitor: {
    getLists: params => axios.post('/screen/sa/syglList', params),
    addRow: params => axios.post('/screen/sa/addSygl', params)
  }, // 水养监控
  RestMonitor: {}, // 静养监控
  YardMonitor: {}, // 堆场监控
  DuctDespatch: {} // 管片发运
}
